import React from 'react';
import ReactDOM from 'react-dom';
import WeatherHeader from './components/WeatherHeader';

document.addEventListener('DOMContentLoaded', function() {
  // Find all weather header containers
  const headerRootElements = document.querySelectorAll('[id^="weather-header-root-"], #weather-header-root');
  
  // Initialize each weather header found
  headerRootElements.forEach(container => {
    if (container) {
      ReactDOM.render(
        <React.StrictMode>
          <WeatherHeader />
        </React.StrictMode>,
        container
      );
    }
  });
}); 